/* eslint-disable max-len */
import React, { Component } from 'react';
import { createBrowserHistory } from 'history';
import { Route, Switch, Router } from 'react-router-dom';

import LoginForm from './user.authentication.components/auth.components/Login/LoginPage';
import SignUpForm from './user.authentication.components/auth.components/SignUp/SignUpForm';
import
SendPasswordLinkPage from
  './user.authentication.components/recover.password.components/SendPasswordLinkPage';
import ChangePasswordForm from
  './user.authentication.components/forget.password.components/ChangePasswordPage';
import LandingPage from './LandingPage';
import InvestPage from './unauthenticated.components/InvestPage';
import LearnPage from './unauthenticated.components/LearnPage';
import SavePage from './unauthenticated.components/SavePage';
import UserRegistrationOTPForm from
  './user.authentication.components/otp.authentication.components/UserRegistrationOTP';
import AboutPage from './unauthenticated.components/AboutPage';
import ContactUsPage from './unauthenticated.components/ContactUs';
import GoalPage from './unauthenticated.components/GoalPage';
import InternetErrConnectPage from './InternetErrConnect';

import CompleteRegistrationSuccess from './user.authentication.components/auth.components/CompleteRegistration';
import NotFoundPage from './NotFound';
import AuthPages from './AuthPages';

/**
 * @class App
 */
class App extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const history = createBrowserHistory();
    return (
      <>


        <div>
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route exact path="/login" component={LoginForm} />
              <Route exact path="/signup" component={SignUpForm} />


              <Route exact path="/reset-password" component={SendPasswordLinkPage} />
              <Route exact path="/change-password" component={ChangePasswordForm} />
              <Route exact path="/invest" component={InvestPage} />
              <Route exact path="/learn" component={LearnPage} />
              <Route exact path="/save" component={SavePage} />


              <Route exact path="/verify-otp" component={UserRegistrationOTPForm} />

              <Route exact path="/about" component={AboutPage} />
              <Route exact path="/contact" component={ContactUsPage} />
              <Route exact path="/goals" component={GoalPage} />
              <Route exact path="/error" component={InternetErrConnectPage} />

              <Route exact path="/register-success" component={CompleteRegistrationSuccess} />

              <AuthPages />

              <Route path="*" component={NotFoundPage} />
            </Switch>
          </Router>
        </div>
      </>
    );
  }
}

export default App;
